module.exports = __webpack_public_path__ + "static/media/google_play.c33ab152.png";